import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { NotificationService } from 'ui-components/services/notification-service';
import { Text, TextType } from 'ui-components/components/text';

import { useModal } from '../../../hooks/use-modal';
import { useSetupComplete } from '../../../hooks/use-seller-setting';

import { LogService } from '../../../services/log-service';
import { ConfirmDialogueModal } from '../../../components/modals/confirm-dialogue-modal/index';
import { SellerSettings } from '../../../enums/seller-settings/seller-settings';
import { saveNewSellerSettings } from '../../../store/seller/seller.actions';
import { updateSellerSettingsBulk } from '../../settings/api/save-settings';

import messages from './messages';
import { Segment } from '../../../services/analytics-services/segment';
import { SHOW_ONBOARDING_GUIDE } from '../../../constants/analytics-events';
import { ONBOARD_PATH } from '../../../routes/constants';

const ConfirmModalBody = () => {
  return (
    <div>
      <h4>
        <FormattedMessage {...messages.showConfirmationBodyHeader} />
      </h4>
      <p>
        <FormattedMessage {...messages.showConfirmationBody} />
      </p>
    </div>
  );
};

const LinkToOnboarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSetupComplete = useSetupComplete();
  const { open: openSaveOnboardVisibility, isOpen, close } = useModal();

  const confirmNavigation = useCallback(async () => {
    close();
    try {
      const newSettings = await updateSellerSettingsBulk({
        [SellerSettings.setupComplete.key]: false,
      });
      dispatch(saveNewSellerSettings(newSettings));
      try {
        Segment.trackEvent(SHOW_ONBOARDING_GUIDE);
      } catch (e) {
        LogService.logError(e);
      }
      navigate(ONBOARD_PATH);
    } catch (error) {
      LogService.logError(error);
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.errorTitle} />,
        content: <FormattedMessage {...messages.errorContent} />,
      });
    }
  }, [navigate, close, dispatch]);

  const linkText = <Text textType={TextType.Paragraph} value={messages.onboardingGuide} />;

  return isSetupComplete ? (
    <>
      <Button onClick={openSaveOnboardVisibility} theme='link'>
        {linkText}
      </Button>
      {isOpen && (
        <ConfirmDialogueModal
          body={<ConfirmModalBody />}
          header={<FormattedMessage {...messages.showOnboardConfirmationHeader} />}
          onClose={close}
          onConfirm={confirmNavigation}
        />
      )}
    </>
  ) : (
    <Link to={ONBOARD_PATH}>{linkText}</Link>
  );
};

export default LinkToOnboarding;
